/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import AppTagNav from './AppTagNav';
import ImageUpload from './ImageUpload';
import IconPicker, { renderIcon } from './IconPicker';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export {
  AppTagNav,
  AvatarDropdown,
  AvatarName,
  Footer,
  IconPicker,
  ImageUpload,
  Question,
  SelectLang,
  renderIcon,
};
